export interface SSOUserData {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  profilePicture?: string;
  provider: SSOProvider;
}

export interface SSOAuthResponse {
  success: boolean;
  userData?: SSOUserData;
  token?: string;
  error?: string;
  errorCode?: string;
}

export enum SSOProvider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  MICROSOFT = 'microsoft',
  APPLE = 'apple',
}

/** Providers turned off in the app (no SDK init, no auth). */
export const DISABLED_SSO_PROVIDERS = new Set<SSOProvider>([SSOProvider.FACEBOOK, SSOProvider.MICROSOFT]);

export function isSsoProviderEnabled(provider: SSOProvider): boolean {
  return !DISABLED_SSO_PROVIDERS.has(provider);
}

export interface SSOConfig {
  clientId?: string;
  identifierId?: string; // For Apple
  appId?: string;
  tenantId?: string; // For Microsoft
  scope?: string;
  redirectUri?: string;
}

export interface SSOError {
  code: string;
  message: string;
  details?: any;
}
